import { render, staticRenderFns } from "./OrderHistoryTable.vue?vue&type=template&id=83e671d8&scoped=true&"
import script from "./OrderHistoryTable.vue?vue&type=script&lang=js&"
export * from "./OrderHistoryTable.vue?vue&type=script&lang=js&"
import style0 from "./OrderHistoryTable.vue?vue&type=style&index=0&id=83e671d8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../Volumes/bsdcDoc/yimanDoc/htdocs/tocin_projects/tocin_web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e671d8",
  null
  
)

export default component.exports